export const incomeTooltip = 'Alimony, child support, or separate maintenance income need not be revealed if you do not wish to have it considered as a basis for repaying the obligation.';

export const monthlyIncomeOptions = [
  { label: 'less than $1000 per month', value: 1000 },
  { label: '$1001 - $2000 per month', value: 2000 },
  { label: '$2001 - $3000 per month', value: 3000 },
  { label: '$3001 - $4000 per month', value: 4000 },
  { label: '$4001 - $5000 per month', value: 5000 },
  { label: '$5001 - $7500 per month', value: 7500 },
  { label: '$7501 - $10,000 per month', value: 10000 },
  { label: 'more than $10,000 per month', value: 12500 },
];
